import React from 'react';
import { PhoneIcon, RefreshCwIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';

interface PairingErrorStateProps {
  error: string | null;
  onRetry: () => void;
}

/**
 * Error state - shown when pairing fails
 */
export const PairingErrorState: React.FC<PairingErrorStateProps> = React.memo(
  ({ error, onRetry }) => (
    <div className='flex flex-col items-center py-8 space-y-4'>
      <div className='rounded-full bg-error-solid/10 p-3'>
        <PhoneIcon className='h-12 w-12 text-error-primary' />
      </div>
      <p className='text-center text-tertiary'>
        {error ?? 'An error occurred'}
      </p>
      <Button
        onClick={onRetry}
        variant={ButtonVariants.SECONDARY}
        size={Sizes.LG}
        iconLeading={RefreshCwIcon}
      >
        Try Again
      </Button>
    </div>
  )
);

PairingErrorState.displayName = 'PairingErrorState';
